/* LCM Offroad: boekingsformulier daktentverhuur. Alle teksten en het valutateken komen uit de
   sectie, zodat het formulier in het Nederlands, Engels, Duits en Frans klopt.
   Verhuur gaat alleen in euro, want ophalen en afrekenen gebeurt in Hoogwoud. Staat de markt in
   een andere valuta, dan verschijnt er geen formulier maar een korte melding met een contactlink. */
(function(){
  var GEEN_EURO = {
    nl: {
      kop: 'Huren kan alleen in euro',
      tekst: 'Onze daktenten verhuren we alleen vanuit Hoogwoud in Nederland, en alleen in euro. Je bekijkt deze winkel nu in een andere valuta. Wil je toch huren? Neem even contact op, dan regelen we het samen.',
      knop: 'Neem contact op'
    },
    en: {
      kop: 'Rentals are in euro only',
      tekst: 'We rent out our rooftop tents from Hoogwoud in the Netherlands only, and only in euro. You are viewing this shop in another currency. Still interested in renting? Get in touch and we will sort it out with you.',
      knop: 'Get in touch'
    },
    de: {
      kop: 'Mieten geht nur in Euro',
      tekst: 'Unsere Dachzelte vermieten wir ausschließlich ab Hoogwoud in den Niederlanden und nur in Euro. Du siehst diesen Shop gerade in einer anderen Währung. Trotzdem Interesse? Melde dich, dann regeln wir das zusammen.',
      knop: 'Kontakt aufnehmen'
    },
    fr: {
      kop: 'La location se fait uniquement en euros',
      tekst: 'Nous louons nos tentes de toit uniquement depuis Hoogwoud aux Pays-Bas, et uniquement en euros. Vous consultez cette boutique dans une autre devise. Intéressé malgré tout ? Contactez-nous et nous verrons cela ensemble.',
      knop: 'Nous contacter'
    }
  };

  function meldGeenEuro(root){
    var taal = (document.documentElement.lang || 'en').slice(0,2);
    var m = GEEN_EURO[taal] || GEEN_EURO.en;
    var wrap = root.querySelector('.lcmb__wrap');
    if (!wrap) return;
    wrap.innerHTML = '';
    var h = document.createElement('h2');
    h.className = 'lcmb__title';
    h.textContent = m.kop;
    var p = document.createElement('p');
    p.className = 'lcmb__intro';
    p.textContent = m.tekst;
    var a = document.createElement('a');
    a.className = 'lcmb__knop';
    a.href = '/pages/contact';
    a.style.display = 'inline-block';
    a.style.textAlign = 'center';
    a.style.textDecoration = 'none';
    a.style.maxWidth = '320px';
    a.textContent = m.knop;
    wrap.appendChild(h);
    wrap.appendChild(p);
    wrap.appendChild(a);
  }

  function start(root){
    var cfgEl = root.querySelector('.lcmb__data');
    if (!cfgEl) return;
    var C = JSON.parse(cfgEl.textContent);
    var VALUTA = C.valuta || '€';
    if (VALUTA.indexOf('€') < 0) { meldGeenEuro(root); return; }

    var T = C.teksten || {};
    var VAR = C.varianten;
    var VLOOT = C.vloot || 1;
    var BORG = C.borg || 0;
    var VOORLOOP = (C.voorlooptijd === undefined || C.voorlooptijd === null) ? 2 : C.voorlooptijd;
    var MAANDEN = T.maanden || ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
    var DAGEN = T.dagen || ['ma','di','wo','do','vr','za','zo'];
    var OMSCHRIJVING = T.omschrijving || {};
    var PERIODES = T.periodes || {};
    var DEC = T.decimaal || ',';
    var ACHTER = T.euroachter === true;
    var DAGPUNT = T.dagpunt === true;

    function tekst(sleutel, standaard){ return T[sleutel] === undefined ? standaard : T[sleutel]; }
    function vul(s, a, b){ return String(s).replace('{a}', a).replace('{b}', b); }

    var vandaag = new Date(); vandaag.setHours(0,0,0,0);
    var vroegst = new Date(vandaag); vroegst.setDate(vroegst.getDate() + VOORLOOP);

    var pakketten = [], periodes = [];
    VAR.forEach(function(v){
      if (pakketten.indexOf(v.pakket) < 0) pakketten.push(v.pakket);
      if (periodes.indexOf(v.periode) < 0) periodes.push(v.periode);
    });

    function label(periode){ return PERIODES[periode] || periode; }
    function nachtenVan(periode){
      var m = String(periode).match(/(\d+)/g);
      if (!m) return 3;
      return parseInt(m[m.length - 1], 10);
    }

    function regel(pakket, periode){
      for (var i=0;i<VAR.length;i++){ if (VAR[i].pakket===pakket && VAR[i].periode===periode) return VAR[i]; }
      return null;
    }
    function huursom(pakket, periode){
      var r = regel(pakket, periode);
      return r ? Math.round(r.cent/100*4) : 0;
    }
    function sleutel(d){
      return d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0'+d.getDate()).slice(-2);
    }

    var bezet = {};
    String(C.bezet || '').split('\n').forEach(function(r){
      var d = r.match(/\d{4}-\d{2}-\d{2}/g);
      if (!d || d.length < 2) return;
      var van = new Date(d[0] + 'T00:00:00'), tot = new Date(d[1] + 'T00:00:00');
      for (var t = new Date(van); t <= tot; t.setDate(t.getDate()+1)) {
        var k = sleutel(t); bezet[k] = (bezet[k] || 0) + 1;
      }
    });
    function vrij(d){ return (bezet[sleutel(d)] || 0) < VLOOT; }

    var staat = { pakket: pakketten[0], periode: periodes[0], datum: null, maand: new Date() };
    staat.maand.setDate(1);

    var elPakket = root.querySelector('.lcmb__cards');
    var elPeriode = root.querySelector('.lcmb__chips');
    var elDagen = root.querySelector('.lcmb__dagen--grid');
    var elMaand = root.querySelector('.lcmb__maand');
    var elKnop = root.querySelector('.lcmb__knop');
    var elMelding = root.querySelector('.lcmb__melding');
    var elKenteken = root.querySelector('.lcmb__kenteken');
    var elBorg = root.querySelector('.lcmb__borg');

    root.querySelector('.lcmb__dagnamen').innerHTML = DAGEN.map(function(d){ return '<span>'+d+'</span>'; }).join('');

    pakketten.forEach(function(p){
      var b = document.createElement('button');
      b.type='button'; b.className='lcmb__card'; b.dataset.pakket=p;
      b.innerHTML = '<b>'+p+'</b><small>'+(OMSCHRIJVING[p]||'')+'</small>';
      b.addEventListener('click', function(){ staat.pakket=p; teken(); });
      elPakket.appendChild(b);
    });
    periodes.forEach(function(p){
      var b = document.createElement('button');
      b.type='button'; b.className='lcmb__chip'; b.dataset.periode=p; b.textContent=label(p);
      b.addEventListener('click', function(){ staat.periode=p; staat.datum=null; teken(); });
      elPeriode.appendChild(b);
    });

    root.querySelector('.lcmb__prev').addEventListener('click', function(){ staat.maand.setMonth(staat.maand.getMonth()-1); teken(); });
    root.querySelector('.lcmb__next').addEventListener('click', function(){ staat.maand.setMonth(staat.maand.getMonth()+1); teken(); });

    function nachten(){ return nachtenVan(staat.periode); }
    function eind(s){ var e = new Date(s); e.setDate(e.getDate()+nachten()); return e; }
    function reeksVrij(s){
      var e = eind(s);
      for (var t = new Date(s); t <= e; t.setDate(t.getDate()+1)) { if (!vrij(t)) return false; }
      return true;
    }
    function nl(d){ return d.getDate() + (DAGPUNT ? '.' : '') + ' ' + MAANDEN[d.getMonth()] + ' ' + d.getFullYear(); }
    function euro(n){
      var s = n.toFixed(2).replace('.', DEC);
      var nul = DEC + '00';
      if (s.slice(-3) === nul) s = s.slice(0, -3);
      return ACHTER ? (s + ' ' + VALUTA) : (VALUTA + ' ' + s);
    }

    function tekenKalender(){
      elMaand.textContent = MAANDEN[staat.maand.getMonth()] + ' ' + staat.maand.getFullYear();
      elDagen.innerHTML = '';
      var eerste = new Date(staat.maand.getFullYear(), staat.maand.getMonth(), 1);
      var offset = (eerste.getDay() + 6) % 7;
      var aantal = new Date(staat.maand.getFullYear(), staat.maand.getMonth()+1, 0).getDate();
      for (var i=0;i<offset;i++){ var leeg=document.createElement('span'); leeg.className='lcmb__dag lcmb__dag--leeg'; elDagen.appendChild(leeg); }
      for (var d=1; d<=aantal; d++){
        var dag = new Date(staat.maand.getFullYear(), staat.maand.getMonth(), d);
        var b = document.createElement('button');
        b.type='button'; b.className='lcmb__dag'; b.textContent=d;
        b.disabled = !(dag >= vroegst && reeksVrij(dag));
        if (staat.datum && sleutel(dag) === sleutel(staat.datum)) b.setAttribute('aria-pressed','true');
        else if (staat.datum && dag > staat.datum && dag <= eind(staat.datum)) b.className += ' lcmb__dag--inrange';
        b.addEventListener('click', (function(x){ return function(){ staat.datum=x; teken(); }; })(dag));
        elDagen.appendChild(b);
      }
    }

    function extras(){
      var lijst=[], bedrag=0, kentekenNodig=false;
      Array.prototype.forEach.call(root.querySelectorAll('.lcmb__extra input:checked'), function(i){
        var navraag = i.dataset.navraag === 'true';
        lijst.push(i.dataset.naam + (navraag ? ' (' + tekst('navraag', 'op navraag') + ')' : ' (' + euro(parseFloat(i.dataset.prijs || 0)) + ')'));
        if (!navraag) bedrag += parseFloat(i.dataset.prijs || 0);
        if (i.dataset.kenteken === 'true') kentekenNodig = true;
      });
      return { lijst: lijst, bedrag: bedrag, kentekenNodig: kentekenNodig };
    }

    function teken(){
      Array.prototype.forEach.call(root.querySelectorAll('.lcmb__card'), function(b){ b.setAttribute('aria-pressed', b.dataset.pakket === staat.pakket ? 'true':'false'); });
      Array.prototype.forEach.call(root.querySelectorAll('.lcmb__chip'), function(b){ b.setAttribute('aria-pressed', b.dataset.periode === staat.periode ? 'true':'false'); });
      tekenKalender();

      var som = huursom(staat.pakket, staat.periode);
      var nu = Math.round(som * 25) / 100;
      var ex = extras();
      root.querySelector('.lcmb__huursom').textContent = euro(som);
      root.querySelector('.lcmb__nu').textContent = euro(nu);
      root.querySelector('.lcmb__rest').textContent = euro(som - nu);
      root.querySelector('.lcmb__extrarij').hidden = ex.bedrag === 0;
      root.querySelector('.lcmb__extrabedrag').textContent = euro(ex.bedrag);
      if (elBorg) elBorg.textContent = euro(BORG);

      var regels = [[tekst('pakket','Pakket'), staat.pakket], [tekst('periode','Periode'), label(staat.periode)]];
      if (staat.datum) {
        regels.push([tekst('ophalen','Ophalen'), nl(staat.datum)]);
        regels.push([tekst('terugbrengen','Terugbrengen'), nl(eind(staat.datum))]);
      } else {
        regels.push([tekst('ophalen','Ophalen'), tekst('kiesdag','kies nog een dag')]);
      }
      if (ex.lijst.length) regels.push([tekst('extras',"Extra's"), ex.lijst.join(', ')]);
      root.querySelector('.lcmb__samenvatting').innerHTML = regels.map(function(r){ return '<dt>'+r[0]+'</dt><dd>'+r[1]+'</dd>'; }).join('');

      root.querySelector('.lcmb__datumtekst').textContent = staat.datum
        ? vul(tekst('datumtekst','Ophalen op {a}, terugbrengen op {b}.'), nl(staat.datum), nl(eind(staat.datum)))
        : vul(tekst('kiesdagtekst','Kies een dag waarop je de tent komt ophalen, vanaf {a}.'), nl(vroegst), '');

      var kenteken = (elKenteken.value || '').trim();
      elKenteken.classList.toggle('lcmb__mis', ex.kentekenNodig && !kenteken);
      if (!staat.datum) { elKnop.disabled = true; elMelding.textContent = tekst('eerstdag','Kies eerst een ophaaldag.'); }
      else if (ex.kentekenNodig && !kenteken) { elKnop.disabled = true; elMelding.textContent = tekst('kentekennodig',''); }
      else { elKnop.disabled = false; elMelding.textContent = ''; }
    }

    root.querySelector('.lcmb__extras').addEventListener('change', teken);
    elKenteken.addEventListener('input', teken);

    elKnop.addEventListener('click', function(){
      if (!staat.datum) return;
      var ex = extras();
      var som = huursom(staat.pakket, staat.periode);
      var nu = Math.round(som * 25) / 100;
      var r = regel(staat.pakket, staat.periode);
      if (!r) return;
      var onbekend = tekst('nietopgegeven','niet opgegeven');
      var bijOphalen = euro(som - nu)
        + (ex.bedrag ? ' ' + tekst('plus','plus') + ' ' + euro(ex.bedrag) + ' ' + tekst('aanextras',"aan extra's") : '')
        + ' ' + vul(tekst('plusborg','plus {a} borg'), euro(BORG), '');
      var props = {};
      props[tekst('pakket','Pakket')] = staat.pakket;
      props[tekst('periode','Periode')] = label(staat.periode);
      props[tekst('ophalen','Ophalen')] = nl(staat.datum);
      props[tekst('terugbrengen','Terugbrengen')] = nl(eind(staat.datum));
      props[tekst('huursomtotaal','Huursom totaal')] = euro(som);
      props[tekst('bijophalen','Bij ophalen te betalen')] = bijOphalen;
      props[tekst('kenteken','Kenteken')] = (elKenteken.value || onbekend).toUpperCase();
      props[tekst('auto','Auto')] = root.querySelector('.lcmb__auto').value || onbekend;
      props[tekst('daktype','Daktype')] = root.querySelector('.lcmb__daktype').value || onbekend;
      if (ex.lijst.length) props[tekst('extras',"Extra's")] = ex.lijst.join(', ');
      var wens = root.querySelector('.lcmb__wensen').value.trim();
      if (wens) props[tekst('eigenwensen','Eigen wensen')] = wens;

      elKnop.disabled = true;
      elMelding.textContent = tekst('bezig','Een moment.');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: r.id, quantity: 1, properties: props }] })
      }).then(function(res){
        if (!res.ok) throw new Error('mislukt');
        window.location.href = '/checkout';
      }).catch(function(){
        elKnop.disabled = false;
        elMelding.textContent = tekst('mislukt','Dat lukte niet.');
      });
    });

    teken();
  }

  function init(){ Array.prototype.forEach.call(document.querySelectorAll('.lcmb[data-lcmb]'), start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();